exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logoCenter {\n  margin-left: auto;\n  margin-right: auto;\n  width: 8%;\n  padding-bottom: 012px;\n  padding-top: 012px; }\n", ""]);

// exports
